import { Box } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';

export const PaymentHeaderWrapper = ({ children }) => {
  const { sm } = useScreen();

  const RowHeader = (
    <Box display="flex" justifyContent="space-between" alignItems={'center'} gridGap={16}>
      {children}
    </Box>
  );

  const ColumnHeader = (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={'center'}
      gridGap={10}
      flexDirection={'column'}
      padding={'5px 0 10px 0'}
    >
      {children}
    </Box>
  );

  if (sm) return RowHeader;
  return ColumnHeader;
};
